
export const enum SortOrder {
    Ascending = 'asc',
    Descending = 'desc'
}

export const enum AttributeNames {
    HasTableSort = 'data-js-table-sort',
    HasTableFilter = 'data-js-table-filter',
    HasMultidimensional = 'data-js-table-multidimensional',
    TableElement = 'data-js-table-element',
    TableScrollIndicatorContainer = 'data-js-table-scroll-indicator-container',
    TableScrollIndicator = 'data-js-table-scroll-indicator',
    TableHead = 'data-js-table-head',
    TableBody = 'data-js-table-body',
    TableCell = 'data-js-table-cell',
    ColumnIndex = 'data-js-column-index',
    RowIndex = 'data-js-row-index',
    SortingOrder = 'data-js-table-sort-order',
    FilterInput = 'data-js-table-filter-input',
    SummaryRow = 'data-js-table-summary-row',
    TableWrapper = 'data-js-table-wrapper'
}